import { SET_MOBILYTICS_SCENARIOS } from "../../../Actions/Types";
import { IGCPBigQueryJob } from "../../../Models/IGCPBigQueryJob";
import { ISafegraphLocation } from "../../../Models/ISafegraphLocation";
import { PolygonType } from "../Models/Maps/Enums/PolygonType";
import { IPolygon } from "../Models/Maps/IPolygon";
import { IMobilyticsScenarioFormState } from "../Pages/Apps/Mobilytics/SubmitMobilyticsLogic";
import {
    CreateCustomLocationParameters,
    LocationDetailsParameters,
    MobilyticsActionType,
    REMOVE_SEARCHED_PLACE_MOBILYTICS_ACTION,
    SET_CREATE_CUSTOM_LOCATION_PARAMETERS_ACTION,
    SET_DRAW_POLYGON_TYPE,
    SET_IN_PROCESS_POLYGON,
    SET_IS_CREATING_CUSTOM_LOCATION_ACTION,
    SET_IS_VIEWING_LOCATION_DETAILS,
    SET_IS_DRAWING_POLYGON,
    SET_IS_REDIRECTED_FROM_CREATE_CUSTOM_LOCATION,
    SET_LOADING_MOBILYTICS_REPORT,
    SET_SAVED_POLYGONS,
    SET_SEARCHED_PLACE_MOBILYTICS_ACTION,
    SUBMIT_MOBILYTICS_REPORT_FAILURE,
    SUBMIT_MOBILYTICS_REPORT_SUCCESS,
    SET_LOCATION_DETAILS_ACTION,
    SearchedPlaceInfo,
    SET_SHOULD_SHOW_END_OF_REPORT_SCREEN_ACTION,
    SET_IS_SEARCHING_FOR_NEW_LOCATION_ACTION,
    SET_NEARBY_LOCATIONS_ACTION, SET_SIMILAR_LOCATIONS_ACTION,
    REMOVE_POLYGON_ACTION,
    SET_MOST_RECENTLY_SUBMITTED_MOBILYTICS_REPORT, SET_SELECTED_SAFEGRAPH_LOCATION_ACTION,
    SET_CUSTOM_REPORT_TITLE,
    SET_IS_LOADING_LOCATIONS,
} from "../Types/MobilyticsActionTypes";

export interface IMobilyticsReducerState {
    isDrawingPolygon: boolean;
    drawPolygonType: PolygonType;
    savedPolygons: IPolygon[];
    inProcessPolygon: IPolygon;
    isLoadingMobilyticsReport: boolean;
    isCreatingCustomLocation: boolean;
    isViewingLocationDetails: boolean;
    isRedirectedFromCreateCustomLocation: boolean;
    createCustomLocationParameters: CreateCustomLocationParameters;
    locationDetailsParameters: LocationDetailsParameters,
    searchedLocation: string;
    searchedLocationName: string;
    searchedLocationIndex: number;
    scenarioFormStates: IMobilyticsScenarioFormState[];
    mostRecentlySubmittedReport: IGCPBigQueryJob[];
    shouldShowEndOfReportScreen: boolean;
    nearbyLocations: ISafegraphLocation[],
    similarLocations: ISafegraphLocation[],
    isSearchingForNewLocation: boolean;
    selectedSafegraphLocation: ISafegraphLocation;
    customReportTitle: string;
    isLoadingLocations: boolean;
}

export const mobilyticsReducerDefaultState: IMobilyticsReducerState = {
    isDrawingPolygon: false,
    drawPolygonType: PolygonType.Rectangle,
    savedPolygons: [],
    inProcessPolygon: null,
    isLoadingMobilyticsReport: false,
    searchedLocation: null,
    searchedLocationName: null,
    searchedLocationIndex: 0,
    scenarioFormStates: [],
    isCreatingCustomLocation: false,
    isViewingLocationDetails: false,
    isRedirectedFromCreateCustomLocation: false,
    createCustomLocationParameters: { address: '' },
    locationDetailsParameters: null,
    mostRecentlySubmittedReport: null,
    shouldShowEndOfReportScreen: false,
    nearbyLocations: [],
    similarLocations: [],
    isSearchingForNewLocation: false,
    selectedSafegraphLocation: null,
    customReportTitle: null,
    isLoadingLocations: false,
};

export const mobilyticsReducer = (
    state: IMobilyticsReducerState = { ...mobilyticsReducerDefaultState },
    action: MobilyticsActionType
): IMobilyticsReducerState => {
    switch (action.type) {
        /** misc */
        case SET_MOST_RECENTLY_SUBMITTED_MOBILYTICS_REPORT: {
            return {
                ...state,
                mostRecentlySubmittedReport: action.data as IGCPBigQueryJob[]
            };
        }
        case SET_IS_DRAWING_POLYGON: {
            return {
                ...state,
                isDrawingPolygon: action.data as boolean,
            };
        }
        case SET_DRAW_POLYGON_TYPE: {
            return {
                ...state,
                drawPolygonType: action.data as PolygonType,
            };
        }
        case SET_SAVED_POLYGONS: {
            return {
                ...state,
                savedPolygons: action.data as IPolygon[],
            };
        }
        case SET_IN_PROCESS_POLYGON: {
            return {
                ...state,
                inProcessPolygon: action.data as IPolygon,
            };
        }
        case SET_LOADING_MOBILYTICS_REPORT: {
            const isLoading = action.data as boolean;
            return {
                ...state,
                isLoadingMobilyticsReport: isLoading
            };
        }
        case SET_SEARCHED_PLACE_MOBILYTICS_ACTION: {
            const place = action.data as SearchedPlaceInfo;
            return {
                ...state,
                searchedLocation: place.placeId,
                searchedLocationName: place.name,
                searchedLocationIndex: state.searchedLocationIndex + 1,
            };
        }
        case REMOVE_SEARCHED_PLACE_MOBILYTICS_ACTION: {
            return {
                ...state,
                searchedLocation: null,
                searchedLocationName: null
            };
        }

        case REMOVE_POLYGON_ACTION: {
            const id = action.data;
            let inProcessPolygonClone = state.inProcessPolygon;

            if (!state.savedPolygons.length) {
                inProcessPolygonClone = null;
            }

            return {
                ...state,
                savedPolygons: state.savedPolygons.filter(polygon => polygon.id !== id),
                inProcessPolygon: inProcessPolygonClone
            };
        }

        case SET_CUSTOM_REPORT_TITLE: {
            return {
                ...state,
                customReportTitle: action.data as string,
            };
        }

        case SET_MOBILYTICS_SCENARIOS: {
            return {
                ...state,
                scenarioFormStates: action.data as IMobilyticsScenarioFormState[]
            };
        }
        case SET_IS_CREATING_CUSTOM_LOCATION_ACTION: {
            const isCreating = action.data as boolean;
            return {
                ...state,
                isCreatingCustomLocation: isCreating
            };
        }
        case SET_IS_VIEWING_LOCATION_DETAILS: {
            const isViewing = action.data as boolean;
            return {
                ...state,
                isViewingLocationDetails: isViewing
            };
        }
        case SET_IS_REDIRECTED_FROM_CREATE_CUSTOM_LOCATION: {
            const isRedirected = action.data as boolean;
            return {
                ...state,
                isRedirectedFromCreateCustomLocation: isRedirected
            };
        }
        case SET_CREATE_CUSTOM_LOCATION_PARAMETERS_ACTION: {
            const data = action.data as CreateCustomLocationParameters;
            return {
                ...state,
                createCustomLocationParameters: data
            };
        }
        case SET_LOCATION_DETAILS_ACTION: {
            const data = action.data as LocationDetailsParameters;
            return {
                ...state,
                locationDetailsParameters: data
            };
        }
        case SET_SHOULD_SHOW_END_OF_REPORT_SCREEN_ACTION: {
            const shouldShowEndOfReportScreen = action.data as boolean;
            return {
                ...state,
                shouldShowEndOfReportScreen,
            };
        }

        case SET_NEARBY_LOCATIONS_ACTION: {
            const locations = action.data as ISafegraphLocation[];
            return {
                ...state,
                nearbyLocations: locations,
            };
        }

        case SET_SIMILAR_LOCATIONS_ACTION: {
            const locations = action.data as ISafegraphLocation[];
            return {
                ...state,
                similarLocations: locations,
            };
        }

        case SET_SELECTED_SAFEGRAPH_LOCATION_ACTION: {
            const location = action.data as ISafegraphLocation;
            return {
                ...state,
                selectedSafegraphLocation: location,
            };
        }

        case SET_IS_SEARCHING_FOR_NEW_LOCATION_ACTION: {
            const isSearchingForNewLocation = action.data as boolean;
            return {
                ...state,
                isSearchingForNewLocation,
            };
        }
        /** success */
        case SUBMIT_MOBILYTICS_REPORT_SUCCESS: {
            return {
                ...state,
                mostRecentlySubmittedReport: action.data as IGCPBigQueryJob[]
            };
        }
        /** failure */
        case SUBMIT_MOBILYTICS_REPORT_FAILURE: {
            return state;
        }

        case SET_IS_LOADING_LOCATIONS: {
            return {
                ...state,
                isLoadingLocations: action.data as boolean
            };
        }

        default: {
            return state;
        }
    }
};
